import React from 'react';
import { Button } from '../components/ui/button';
import logoSvg from '../assets/logo.svg';
interface SessionExpiredModalProps {
  open: boolean;
  onClose?: () => void;
}

const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({ open, onClose }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur">
      <div className="relative flex flex-col items-center justify-center z-10">
        <img src={logoSvg} width={150} height={150} className="drop-shadow-lg" alt="Logo" />
        <div className="bg-white/90 dark:bg-zinc-900/90 p-10 rounded-2xl shadow-2xl max-w-md w-full text-center backdrop-blur-md border border-zinc-200 dark:border-zinc-800">
          <h1 className="text-4xl font-extrabold mb-4 text-indigo-700 dark:text-indigo-300 tracking-tight">Session Expired</h1>
          <p className="mb-8 text-lg text-zinc-700 dark:text-zinc-300">
            You have been logged out due to inactivity or a forced logout.<br />
            Please log in again to continue using the system.
          </p>
          <Button onClick={() => { if (onClose) onClose(); window.location.href = '/login'; }} className="w-full text-lg py-2 font-semibold">
            Log In
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredModal; 